import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const selectedVisitStorage = createJSONStorage<string | null>(
  () => sessionStorage,
);

export const selectedVisitAtom = atomWithStorage(
  'jotai-selected-visit',
  null,
  selectedVisitStorage,
);

export const selectedUnifiedIdAtom = atomWithStorage(
  'jotai-selected-unified-id',
  null,
  selectedVisitStorage,
);
